import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AlertClassColour, ConfigSystemParams, DgActionColumnWidth, DgColumnDataType, DgColumnWidths, eSimApiPaths, GridViewTitles, msSize } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, firstValueFrom, Observable, throwError } from 'rxjs';
import { CompanyModalFormComponent } from '../_company/company-modal-form/company-modal-form.component';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { DgTab } from 'src/app/core/interfaces/datagrid/dg-tab';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InviewUserDTO } from 'src/app/core/models/inview/inview-user.dto';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { ModalForceCloseService } from 'src/app/core/services/utelize/general/modal-force-close-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PageCompHeaderComponent } from "src/app/core/page-components/page-comp-header/page-comp-header.component";
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { UserGroupAllocationDTO } from 'src/app/core/models/system/user-group/user-group-allocation.dto';
import { UserGroupDTO } from 'src/app/core/models/system/user-group/user-group.dto';
import { UserGroupService } from 'src/app/core/services/utelize/system/user-group/user-group-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

const apiPath             =environment.eSimApi+eSimApiPaths.UserGroups+"/"+eSimApiPaths.UserGroupsGetAllUsersForGroupId;
const apiPathUserGroup    =environment.eSimApi+eSimApiPaths.UserGroups+"/"+eSimApiPaths.UserGroupsGetAllGroupsForUser;
const exportFilenameSuffix="UserGroup-Details";
const mainTitle           =GridViewTitles.userGroup;
const popUpTitle          =GridViewTitles.userGroup;

@Component({
  selector: 'app-user-groups-modal-edit-form',
  templateUrl: './user-groups-modal-edit-form.component.html',
  styleUrls: ['./user-groups-modal-edit-form.component.scss'],
  providers: [GridViewService]
  //encapsulation: ViewEncapsulation.None
})

export class UserGroupModalEditFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() embeddedFormMode      : boolean | undefined;
  @Input() initialCompanyId      : number  | undefined;
  @Input() initialInviewCompanyId: number  | undefined;

  @Output() userGroupFormCancelled   : EventEmitter<void> = new EventEmitter<void>();
  @Output() userGroupDataHasBeenSaved: EventEmitter<any>  = new EventEmitter<any>();
  
  @ViewChild('userGroupModalFormContent',    { static: false }) userGroupModalFormContent!     : TemplateRef<void>;
  @ViewChild('companyModalForm',             { static: false }) companyModalForm!              : CompanyModalFormComponent;
  @ViewChild('completedModalForm',           { static: false }) completedModalForm!            : CompletedModalFormComponent;
  @ViewChild('gridViewUsers',                { static: false }) gridViewUsers!                 : GridViewComponent;
  @ViewChild('gridViewGroups',               { static: false }) gridViewGroups!                : GridViewComponent;
  @ViewChild(PageCompHeaderComponent                          ) pageHeader!                    : PageCompHeaderComponent;
  @ViewChild('warningModalForm',             { static: false }) warningModalForm!              : WarningModalFormComponent;
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static"     : (value.toUpperCase()=="TRUE" ? true : false) }

  private curUser                      : SystemUserDTO;
  private gridViewDefaults!            : GridViewDefaults;
  private initialInviewCompanyIdSet    : boolean=false;
  private initialStatus                : string="Please complete the following details";
  private inviewCompanyIdData!         : IdAndDescriptionDTO[];
  private inviewUserIdData!            : InviewUserDTO[];
  private userGroup                    : UserGroupDTO | undefined;
  private userGroupModalFormRef!       : NgbModalRef;
  private userGroupSavedMessage        : string="Changes applied.";
 
  public activeId                      : number = 1;
  public activeIdUserGroup             : number = 1;
  public alertColourOrderStatus        : string=AlertClassColour.Grey;
  public alertColourProgress           : string=AlertClassColour.Grey;
  public breadCrumbItems!              : Array<{}>;
  public defaultOpen                   : boolean = false;
  public defaultTemplate               : boolean = false;
  public dgApiPathUsers!               : DgApiPath | undefined;
  public dgApiPathGroups!              : DgApiPath | undefined;
  public dgActionColumnUsers!          : DgActionColumn | undefined;
  public dgActionColumnGroups!         : DgActionColumn | undefined;
  public dgColumnsUsers!               : Array<DgColumn>;
  public dgColumnsGroups!              : Array<DgColumn>;
  public dgPopupUsers!                 : DgPopup | undefined;
  public dgPopupGroups!                : DgPopup | undefined;
  public dgPropertiesUsers!            : DgProperties | undefined;
  public dgPropertiesGroups!           : DgProperties | undefined;
  public dgTabsUsers!                  : Array<DgTab>;
  public dgTabsGroups!                 : Array<DgTab>;
  public dropDownStatus                : any = {};
  public filterCompanyID               : number = -1;
  public formSubmitted                 : boolean=false;
  public formTitle                     : string="User Group";
  public groupsGridVisible             : boolean=false;
  public inviewCompanyId               : number | undefined;
  public provisionButtonEnabled        : boolean=false;
  public progressInformation           : string=this.initialStatus;
  public reassignUserGroupData         : any;
  public submitButtonEnabled           : boolean=true;
  public sureSimCompanyId              : number | undefined;
  public userGroupFilterApplied        : boolean=false;
  public userGroupForm!                : UntypedFormGroup;
  public userGroupId                   : number=0;
  public userGroupUserGroupFilterApplied: boolean=false;
  public userGridVisible               : boolean=false;
  public userId                        : number=0;
  public warningMessageMain            : string | undefined;
  public warningMessageSub             : string | undefined;

  //#region for Validators
  
  public nameMaxLength                : number=100;
  
  //#endregion 

  //#region NavItems
 
  public navItemLog_User_Included  : number=1;
  public navItemLog_User_Excluded  : number=2;
  
  public navItemLog_Group_Included : number=1;
  public navItemLog_Group_Excluded : number=2;
  //#endregion

  constructor(
    private userGroupsService         : UserGroupService,
    private authenticationService     : AuthenticationService,
    // private changeDetectorRef         : ChangeDetectorRef,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private encryptionService         : EncryptionService,
    private exceptionsService         : ExceptionsService,
    private formBuilder               : UntypedFormBuilder,
    private gridViewService           : GridViewService,
    private gridViewServiceUserGroup  : GridViewService,
    private lastPassKillerService     : LastPassKillerService,
    private modalForceCloseService    : ModalForceCloseService,
    private modalService              : NgbModal
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  public async ngOnInit(): Promise<void> {
    try {
      await this.setUpDgApiPathsUsers();
      this.setUpDgActionColumnUsers();
      this.setUpDgColumnsUsers();
      this.setUpDgPopupUsers();
      this.setUpDgPropertiesUsers();
      this.setUpDgTabsUsers();

      await this.setUpDgApiPathsGroups();
      this.setUpDgActionColumnGroups();
      this.setUpDgColumnsGroups();
      this.setUpDgPopupGroups();
      this.setUpDgPropertiesGroups();
      this.setUpDgTabsGroups();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy() {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.alertColourProgress            =AlertClassColour.Grey;
      this.userGroupFilterApplied         =false;
      this.userGroupUserGroupFilterApplied=false;
      this.formSubmitted                  =false;
      this.activeId                       =1;
      this.activeIdUserGroup              =1;
      this.defaultTemplate                =false;
      this.setUpDgActionColumnGroups();
      this.setUpDgPropertiesGroups();
      this.setUpDgActionColumnUsers();
      this.setUpDgPropertiesUsers();

      if (this.gridViewUsers != undefined) {
        this.reapplyFilterUsers();
      }

      if (this.gridViewGroups != undefined) {
        this.reapplyFilterGroups();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public closeForm(): void {
    try {
      this.userGroupModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async openFormGroup(userGroupId: number, companyId: number): Promise<void> {
    try {
      this.sureSimCompanyId = companyId;
      this.filterCompanyID  = companyId;
      this.userGroupId      = userGroupId;
      this.groupsGridVisible= false;
      this.userGridVisible  = true;
      this.resetMainVariables();
      this.startProcess();
  
      await this.getuserGroupAndOpenModal(userGroupId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public async openFormUser(userId: number, companyId: number): Promise<void> {
    try {
      this.sureSimCompanyId = companyId;
      this.filterCompanyID  = companyId;
      this.userGroupId      = -1;
      this.userId           = userId;
      this.groupsGridVisible= true;
      this.userGridVisible  = false;
      this.resetMainVariables();
      this.startProcess();
  
      await this.getuserGroupsAndOpenModal(userId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  
  private async getuserGroupAndOpenModal(userGroupId: number): Promise<void> {
    try {
      if (userGroupId > 0) {
        const data=await firstValueFrom(this.userGroupsService.getById(userGroupId)
                                        .pipe(
                                          catchError(error => {
                                            throw new Error(this.exceptionsService.formatHttpError(error));
                                          })
                                        ));
  
        this.userGroup=data;
  
        this.populateFormFieldsUser();
        //this.validateProduct();
  
        await this.setDgApiPathGetUsers(true);
        //await this.setDgApiPathGetGroups(true);
     
        this.openModal();
  
        return;
      }
  
      this.userGroup = {
        active      : true,
        companyID   : -1,
        enteredBy   : -1,
        fullname    : '',
        id          : -1,
        groupName   : '',
        allocations : [],
        systemOwned : false,
        username    : '',
      };
  
      this.populateFormFieldsUser();
  
      await this.setDgApiPathGetUsers(true);
      //await this.setDgApiPathGetGroups(true);
  
      this.openModal();
  
    }
    catch (e) {
      this.userGroupFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async getuserGroupsAndOpenModal(userId: number): Promise<void> {
    try {
      if (userId > 0) {
        const data=await firstValueFrom(this.userGroupsService.UserGroupsGetUserGroupByUserId(userId)
                                        .pipe(
                                          catchError(error => {
                                            throw new Error(this.exceptionsService.formatHttpError(error));
                                          })
                                        ));
  
        this.userGroup=data;
  
        this.populateFormFieldsUser();
        //this.validateProduct();
  
        //await this.setDgApiPathGetUsers(true);
        await this.setDgApiPathGetGroups(true);
     
        this.openModal();
  
        return;
      }
  
      this.userGroup = {
        active      : true,
        companyID   : -1,
        enteredBy   : -1,
        fullname    : '',
        id          : -1,
        groupName   : '',
        allocations : [],
        systemOwned : false,
        username    : '',
      };
  
      this.populateFormFieldsUser();
  
      //await this.setDgApiPathGetUsers(true);
      await this.setDgApiPathGetGroups(true);
  
      this.openModal();
  
    }
    catch (e) {
      this.userGroupFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
        this.userGroupModalFormRef = this.modalService.open(this.userGroupModalFormContent, {
                                                                                      backdrop     : this.modalBackGround, 
                                                                                      centered     : true,
                                                                                      keyboard     : false,
                                                                                      size         : msSize.ExtraLarge, 
                                                                                      beforeDismiss: () => { return this.modalForceCloseService.isForcing(); },
                                                                                      }); 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private populateFormFieldsUser() {
    try {
      if (this.userGroup != undefined) {
        this.userGroupForm.controls["active"].setValue(this.userGroup.active);
        this.userGroupForm.controls["companyId"].setValue(this.userGroup.companyID);
        this.userGroupForm.controls["id"].setValue(this.userGroup.id);
        this.userGroupForm.controls["groupName"].setValue(this.userGroup.groupName);
        this.userGroupForm.controls["systemOwned"].setValue(this.userGroup.systemOwned);
      }        
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private startProcess(): void {
    try {
      this.resetMainVariables();
      this.refreshData();
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region userGroupForm

  get formData() {
    return this.userGroupForm.controls;
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.userGroupForm);
      this.userGroupForm=this.formBuilder.group({ });
      this.addFormFields(this.userGroupForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.userGroupForm) {
        this.addFormControl(formGroup, "active",                    "", []);
        this.addFormControl(formGroup, "companyId",                 "", []);
        this.addFormControl(formGroup, "id",                        "", []);
        this.addFormControl(formGroup, "groupName",                 "", [Validators.required, Validators.maxLength(this.nameMaxLength)]);
        this.addFormControl(formGroup, "systemOwned",               "", []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public showGroupsGrid() {
    let result = this.groupsGridVisible;
    return result;
  }

  public showUsersGrid() {
    let result = this.userGridVisible;
    return result;
  }
  
  public userGroupFormCancel() {
    try {
      this.userGroupFormCancelled.emit();
      this.userGroupModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onActiveCheckboxChange() {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userGroupCompletedModalHasBeenClosed() {
    try {
      this.userGroupModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get formOfuserGroupAdd() {
    return this.userGroupForm.controls;
  }

  public isNumber(value: any): boolean {
    return !isNaN(Number(value)) && typeof value !== 'boolean';
  }

  public userGroupFormSubmitAttempt() {
    try {

      this.formSubmitted=true; 

      //this.validateProduct();
      
      if (this.userGroupValidation()) {
        this.userGroupFormSubmit();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userGroupValidation(): boolean {
    return true;
  }

  public userGroupFormSubmit() {
    try {
      this.prepareToSaveUserGroup();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private prepareToSaveUserGroup() {
    try {
      if (this.userGroup != undefined)
      {
        this.userGroup.active                  = this.userGroupForm.controls["active"].value;
        this.userGroup.companyID               = this.sureSimCompanyId;
        this.userGroup.enteredBy               = this.curUser.userId;
        this.userGroup.id                      = this.userGroupForm.controls["id"].value;
        this.userGroup.groupName               = this.showGroupsGrid() ? "¬¬!!PUT!!¬¬" : this.userGroupForm.controls["groupName"].value;
        this.userGroup.systemOwned             = this.userGroupForm.controls["systemOwned"].value;
 
        this.saveuserGroup(this.userGroup)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.alertColourProgress=AlertClassColour.Green;
            this.userGroupDataHasBeenSaved.emit();
            this.saveOrderProcessComplete();
          },
          error: error => {
            this.alertColourProgress=AlertClassColour.Red;
            this.progressInformation=`Process cannot continue - ${error.message}`;
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveOrderProcessComplete() {
    try {
      this.completedModalForm.openForm(this.userGroupSavedMessage, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveuserGroup(userGroup: UserGroupDTO): Observable<UserGroupDTO> {
    return this.userGroupsService.save(userGroup);
  }

  public reapplyFilterUsers() {
    let filterValue: any;
    if (this.activeId == this.navItemLog_User_Included) {
      filterValue = ['included', '=', true];
    }
    else {
      filterValue = ['excluded', '=', true];
    }
    const gridInstance = this.gridViewUsers.dataGrid.instance;  
    gridInstance.clearFilter(); // Clear the existing filter
    gridInstance.filter(filterValue); // Reapply the filter
  }

  public repaintUserGrid() {
    const gridInstance = this.gridViewUsers.dataGrid.instance; 
    gridInstance.refresh();
  }

  public repaintUserGroupGrid() {
    const gridInstance = this.gridViewGroups.dataGrid.instance; 
    gridInstance.refresh();
  }

  public reapplyFilterGroups() {
    const gridInstance = this.gridViewGroups.dataGrid.instance; 
    var combinedFilter = gridInstance.getCombinedFilter(true);
    var existingFilters : any[] = [];

    if (combinedFilter != undefined) {
      combinedFilter.forEach((filter: any) =>
      {
        if (filter?.columnIndex != undefined) {
          existingFilters.push(filter);
        }
      });
    }

    let filterValue: any;
    if (this.activeIdUserGroup == this.navItemLog_User_Included) {
      filterValue = ['included', '=', true];
    }
    else {
      filterValue = ['excluded', '=', true];
    }
    gridInstance.clearFilter(); // Clear the existing filter
    gridInstance.filter(filterValue); // Reapply the filter

    existingFilters.forEach((filter: any) =>
     {
       if (filter?.columnIndex != undefined) {
         this.dgColumnsGroups[Number(filter?.columnIndex)].filterValue = filter?.filterValue;
         this.dgColumnsGroups[Number(filter?.columnIndex)].selectedFilterOperation = filter?.selectedFilterOperation;
       } 
     });
  }

  public usersOnContentReady(event: any) { 
    if (!this.userGroupFilterApplied)
    {
      this.userGroupFilterApplied = true;
      this.reapplyFilterUsers();
    }
  }

  public groupsOnContentReady(event: any) { 
    if (!this.userGroupUserGroupFilterApplied)
    {
      this.userGroupUserGroupFilterApplied = true;
      this.reapplyFilterGroups();
    }
  }

  public usersOnTabChange(event: any) {
    try {
      this.activeId = <number>event;

      if (this.activeId == this.navItemLog_User_Excluded) {
        this.dgPropertiesUsers!.button1Options   = {
          text : "Include All",
          elementAttr: { style: "background-color: #299CDB; color: white;" },
          width: 100,
          onClick: () => {
            this.includeAllUsers();
          },
        };
      } else if (this.activeId == this.navItemLog_User_Included) {
        this.dgPropertiesUsers!.button1Options   = {
          text : "Remove All",
          elementAttr: { style: "background-color: #F06548; color: white;" },
          width: 100,
          onClick: () => {
            this.removeAllUsers();
          },
        };
      }

      this.gridViewUsers.repaintGrid();

      this.reapplyFilterUsers();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public groupsOnTabChange(event: any) {
    try {
      this.activeIdUserGroup = <number>event;

      if (this.activeIdUserGroup == this.navItemLog_Group_Excluded) {
        this.dgPropertiesGroups!.button1Options   = {
          text : "Include All",
          elementAttr: { style: "background-color: #299CDB; color: white;" },
          width: 100,
          onClick: () => {
            this.includeAllGroups();
          },
        };
      } else if (this.activeIdUserGroup == this.navItemLog_Group_Included) {
        this.dgPropertiesGroups!.button1Options   = {
          text : "Remove All",
          elementAttr: { style: "background-color: #F06548; color: white;" },
          width: 100,
          onClick: () => {
            this.removeAllGroups();
          },
        };
      }

      this.gridViewGroups.repaintGrid();

      // this.setUpDgColumnsGroups();
      this.reapplyFilterGroups();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async setDgApiPathGetUsers(refreshdata:boolean): Promise<void> {
    try {
      const idToEncrypt=<string>(this.userGroupId ?? -1).toString();
      const idEncResult=await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(idToEncrypt, true));
      const idEncSS    =idEncResult.result;

      const companyIdToEncrypt=<string>(this.sureSimCompanyId ?? -1).toString();
      const companyIdEncResult=await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(companyIdToEncrypt));
      const companyIdEnc      =companyIdEncResult.result;
      
      this.dgApiPathUsers!.get=environment.eSimApi +
                          eSimApiPaths.UserGroups + '/' +
                          eSimApiPaths.UserGroupsGetAllUsersForGroupId +
                          "?idEncSS=" + idEncSS +
                          "&companyIdEnc=" + companyIdEnc;

      this.gridViewService.apiPathGet=this.dgApiPathUsers!.get;

      if (refreshdata == true && this.gridViewUsers != null) {
        this.gridViewUsers.refreshData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  } 

  public async setDgApiPathGetGroups(refreshdata:boolean): Promise<void> {
    try {
      const idToEncrypt      =<string>(this.userId ?? -1).toString();
      const userIdEncSSResult=await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(idToEncrypt, true));
      const userIdEncSS      =userIdEncSSResult.result;
      
      this.dgApiPathGroups!.get=environment.eSimApi +
                                    eSimApiPaths.UserGroups + '/' +
                                    eSimApiPaths.UserGroupsGetAllGroupsForUser +
                                    "?userIdEncSS=" + userIdEncSS;

      this.gridViewServiceUserGroup.apiPathGet=this.dgApiPathGroups!.get;

      if (refreshdata == true && this.gridViewGroups != null) {
        this.gridViewGroups.refreshData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  } 

private async setUpDgApiPathsUsers(): Promise<void> {
    try {
      this.dgApiPathUsers     =this.gridViewDefaults.setUpDgApiPaths(apiPath)
      this.dgApiPathUsers!.get=environment.eSimApi+eSimApiPaths.UserGroups+"/"+eSimApiPaths.UserGroupsGetAllGroupsForUser;
      await this.setDgApiPathGetUsers(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumnUsers() {
    try {
      this.dgActionColumnUsers                          =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumnUsers!.allowDeleting           =true;
      this.dgActionColumnUsers!.allowMore               =false;
      this.dgActionColumnUsers!.cellTemplate            ="DataDrivenButtons";
      this.dgActionColumnUsers!.deleteIcon              ="assets/images/_suresim/Button Remove 55x23.png";
      this.dgActionColumnUsers!.deleteRowButtonCondition=(data:any) => {  
        let result = data.included == true;
        return result; 
      };
      this.dgActionColumnUsers!.overrideDelete          =true;
      this.dgActionColumnUsers!.updateIcon              ="assets/images/_suresim/Button Include 55x23.png";
      this.dgActionColumnUsers!.updateRowButtonCondition=(data:any) => {  
        let result = data.excluded == true;
        return result; 
      };
      this.dgActionColumnUsers!.width=DgActionColumnWidth.oneButtonWithLeftRightPadding;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopupUsers() {
    try {
      this.dgPopupUsers               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopupUsers!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPropertiesUsers() {
    try {
      this.dgPropertiesUsers                   =this.gridViewDefaults.setUpDgProperties(mainTitle, exportFilenameSuffix);
      this.dgPropertiesUsers!.button1Options   = {
          text : "Remove All",
          elementAttr: { style: "background-color: #F06548; color: white;" },
          width: 100,
          onClick: () => {
            this.removeAllUsers();
          },
        },
      this.dgPropertiesUsers!.encryptDeleteSS  =true;
      this.dgPropertiesUsers!.encryptPost      =true;
      this.dgPropertiesUsers!.encryptPut       =true;
      this.dgPropertiesUsers!.gridKey          ="UserGroupsModalEditFormUsers";
      this.dgPropertiesUsers!.initialTab       =this.navItemLog_User_Included; 
      this.dgPropertiesUsers!.pageSize         =5,
      this.dgPropertiesUsers!.remoteOperations =false;
      //this.dgPropertiesUsers!.cacheEnabled     =false;
      this.dgPropertiesUsers!.showAddButton    =false;
      this.dgPropertiesUsers!.showRefreshButton=true;
      this.dgPropertiesUsers!.showTabs         =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumnsUsers() {
    try {
      let dgColumn: DgColumn | undefined;
      
      //ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.formVisible=false;
      dgColumn!.gridVisible=false;//this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width      =DgColumnWidths.id;
      this.dgColumnsUsers       =[dgColumn!];

      //Included
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("included", "Included", "", DgColumnDataType.string);
      dgColumn!.formVisible       =false;
      dgColumn!.gridVisible       =false;
      dgColumn!.width             =68;
      this.dgColumnsUsers.push(dgColumn!);

      //Excluded
      dgColumn                    =this.gridViewDefaults.setUpDgColumn("excluded", "Excluded", "", DgColumnDataType.string);
      dgColumn!.formVisible       =false;
      dgColumn!.gridVisible       =false;
      dgColumn!.width             =68;
      this.dgColumnsUsers.push(dgColumn!);
      
      //Fullname
      dgColumn             =this.gridViewDefaults.setUpDgColumn("fullname", "User", "", DgColumnDataType.string);
      dgColumn!.gridVisible=this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowFullname, true);
      // dgColumn!.cellTemplate    ="FullNameTemplate"; //RBW20250716 - This will cause a Circular Dependencies, resulting in a Maximum call stack size exceeded, if this and the html bits are enabled
      // dgColumn!.cellTemplateType="link"f
      this.dgColumnsUsers.push(dgColumn!);

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgTabsUsers() {
    try {
      let dgTab: DgTab | undefined;
      
      //Included
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_User_Included, "Included");
      this.dgTabsUsers  =[dgTab!];

      //Excluded
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_User_Excluded, "Excluded");
      this.dgTabsUsers.push(dgTab!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

private async setUpDgApiPathsGroups(): Promise<void> {
    try {
      this.dgApiPathGroups     =this.gridViewDefaults.setUpDgApiPaths(apiPathUserGroup)
      this.dgApiPathGroups!.get=environment.eSimApi+eSimApiPaths.UserGroups+"/"+eSimApiPaths.UserGroupsGetAllUsersForGroupId;
      await this.setDgApiPathGetGroups(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumnGroups() {
    try {
      this.dgActionColumnGroups                          =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumnGroups!.allowDeleting           =true;
      this.dgActionColumnGroups!.allowMore               =false;
      this.dgActionColumnGroups!.cellTemplate            ="DataDrivenButtons";
      this.dgActionColumnGroups!.deleteIcon              ="assets/images/_suresim/Button Remove 55x23.png";
      this.dgActionColumnGroups!.deleteRowButtonCondition=(data:any) => {  
        let result = data.included == true;
        return result; 
      };
      this.dgActionColumnGroups!.overrideDelete          =true;
      this.dgActionColumnGroups!.updateIcon              ="assets/images/_suresim/Button Include 55x23.png";
      this.dgActionColumnGroups!.updateRowButtonCondition=(data:any) => {  
        let result = data.excluded == true;
        return result; 
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopupGroups() {
    try {
      this.dgPopupGroups               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopupGroups!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPropertiesGroups() {
    try {
      this.dgPropertiesGroups                   =this.gridViewDefaults.setUpDgProperties(mainTitle, exportFilenameSuffix);
      this.dgPropertiesGroups!.button1Options   = {
          text : "Remove All",
          elementAttr: { style: "background-color: #F06548; color: white;" },
          width: 100,
          onClick: () => {
            this.removeAllGroups();
          },
        },
      this.dgPropertiesGroups!.encryptDeleteSS  =true;
      this.dgPropertiesGroups!.encryptPost      =true;
      this.dgPropertiesGroups!.encryptPut       =true;
      this.dgPropertiesGroups!.gridKey          ="UserGroupsModalEditFormGroups";
      this.dgPropertiesGroups!.initialTab       =this.navItemLog_Group_Included;
      this.dgPropertiesGroups!.pageSize         =5,
      this.dgPropertiesGroups!.remoteOperations =false;
      //this.dgPropertiUserGroupes!.cacheEnabled     =false;
      this.dgPropertiesGroups!.showAddButton    =false;
      this.dgPropertiesGroups!.showRefreshButton=true;
      this.dgPropertiesGroups!.showTabs         =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumnsGroups() {
    try {
      let dgColumnUserGroup: DgColumn | undefined;
      
      //ID
      dgColumnUserGroup             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumnUserGroup!.formVisible=false;
      dgColumnUserGroup!.gridVisible=false;//this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumnUserGroup!.width      =DgColumnWidths.id;
      this.dgColumnsGroups       =[dgColumnUserGroup!];

      //userGroupName
      dgColumnUserGroup                  =this.gridViewDefaults.setUpDgColumn("groupName", "Group", "", DgColumnDataType.string); //userGroupName
      dgColumnUserGroup!.formVisible     =true;
      dgColumnUserGroup!.gridVisible     =true;
      this.dgColumnsGroups.push(dgColumnUserGroup!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgTabsGroups() {
    try {
      let dgTabUserGroup: DgTab | undefined;
      
      //Included
      dgTabUserGroup             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Group_Included, "Included");
      this.dgTabsGroups       =[dgTabUserGroup!];

      //Excluded
      dgTabUserGroup             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Group_Excluded, "Excluded");
      this.dgTabsGroups.push(dgTabUserGroup!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public usersIncludeButtonClick(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.included   = true;
        row.excluded   = false;
        row.changed    = true;

        let index = this.userGroup?.allocations.findIndex(item => item.id === row.id);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active       : true,
                            changed      : true,
                            companyID    : row.companyID,
                            deleted      : false,
                            enteredBy    : this.curUser.userId,
                            enteredDate  : new Date(2025, 1, 1, 0, 0, 0, 0),
                            excluded     : false,
                            groupId      : this.userGroupId,
                            id           : row.id,
                            included     : true,
                            systemOwned  : false,
                            userId       : row.userId,
                            // externalRef  : "",
                            fullname     : "",
                            // internalRef  : "",
                            groupName    : "",
                            username     : "",
                          };

          this.userGroup?.allocations.push(newItem);
        } else {
          this.userGroup!.allocations[index].changed  = true;
          this.userGroup!.allocations[index].excluded = false;
          this.userGroup!.allocations[index].included = true;
        }
      }

      this.reapplyFilterUsers();
      this.gridViewUsers.dataGrid.instance.repaintRows;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }

  public usersRemoveButtonClick(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.included   = false;
        row.excluded   = true;
        row.changed    = true;

        let index = this.userGroup?.allocations.findIndex(item => item.id === row.id);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active       : true,
                            changed      : true,
                            companyID    : row.companyID,
                            deleted      : false,
                            enteredBy    : this.curUser.userId,
                            enteredDate  : new Date(2025, 1, 1, 0, 0, 0, 0),
                            excluded     : true,
                            id           : row.id,
                            included     : false,
                            systemOwned  : false,
                            groupId      : this.userGroupId,
                            userId       : row.userId,
                            // externalRef  : "",
                            fullname     : "",
                            // internalRef  : "",
                            groupName    : "",
                            username     : "",
                          };

          this.userGroup?.allocations.push(newItem);
        } else {
          this.userGroup!.allocations[index].changed  = true;
          this.userGroup!.allocations[index].excluded = true;
          this.userGroup!.allocations[index].included = false;
        }
      }

      this.reapplyFilterUsers();
      this.gridViewUsers.dataGrid.instance.repaintRows;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public includeAllUsers() {
    const gridInstance = this.gridViewUsers.dataGrid.instance; 
    var combinedFilter = gridInstance.getCombinedFilter();
    var datasource     = gridInstance.getDataSource();
    datasource.store().load({ filter: combinedFilter }).then((data) => {
      var rows = data as UserGroupAllocationDTO[];
      rows.forEach((item) => {
        item.changed = true;
        item.excluded= false;
        item.included= true;
        let index = this.userGroup?.allocations.findIndex(itemb => itemb.id === item.id);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active       : true,
                            changed      : true,
                            companyID    : item.companyID,
                            deleted      : false,
                            enteredBy    : this.curUser.userId,
                            enteredDate  : new Date(2025, 1, 1, 0, 0, 0, 0),
                            excluded     : false,
                            id           : item.id,
                            included     : true,
                            systemOwned  : false,
                            groupId      : this.userGroupId,
                            userId       : item.userId,
                            // externalRef  : "",
                            fullname     : "",
                            // internalRef  : "",
                            groupName    : "",
                            username     : "",
                          };

          this.userGroup?.allocations.push(newItem);
        } else {
          this.userGroup!.allocations[index].changed  = true;
          this.userGroup!.allocations[index].excluded = false;
          this.userGroup!.allocations[index].included = true;
        }
      }
    )});

    //this.setUpDgColumnsGroups();
    this.repaintUserGrid();
  }

  public removeAllUsers() {
    const gridInstance = this.gridViewUsers.dataGrid.instance;  
    var combinedFilter = gridInstance.getCombinedFilter();
    var datasource = gridInstance.getDataSource();
    datasource.store().load({ filter: combinedFilter }).then((data) => {
      var rows = data as UserGroupAllocationDTO[];
      rows.forEach((item) => {
        item.changed = true;
        item.excluded= true;
        item.included= false;
        let index = this.userGroup?.allocations.findIndex(itemb => itemb.id === item.id);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active       : true,
                            changed      : true,
                            companyID    : item.companyID,
                            deleted      : false,
                            enteredBy    : this.curUser.userId,
                            enteredDate  : new Date(2025, 1, 1, 0, 0, 0, 0),
                            excluded     : true,
                            id           : item.id,
                            included     : false,
                            systemOwned  : false,
                            groupId      : this.userGroupId,
                            userId       : item.userId,
                            // externalRef  : "",
                            fullname     : "",
                            // internalRef  : "",
                            groupName    : "",
                            username     : "",
                          };

          this.userGroup?.allocations.push(newItem);
        } else {
          this.userGroup!.allocations[index].changed  = true;
          this.userGroup!.allocations[index].excluded = true;
          this.userGroup!.allocations[index].included = false;
        }
      }
    )});

    //this.setUpDgColumnsGroups();
    this.repaintUserGrid();
  }

  public groupsIncludeButtonClick(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.included   = true;
        row.excluded   = false;
        row.changed    = true;

        let index = this.userGroup?.allocations.findIndex(item => item.groupId === row.groupId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active       : true,
                            changed      : true,
                            companyID    : row.companyID,
                            deleted      : false,
                            enteredBy    : this.curUser.userId,
                            enteredDate  : new Date(2025, 1, 1, 0, 0, 0, 0),
                            excluded     : false,
                            id           : row.id,
                            included     : true,
                            systemOwned  : false,
                            groupId      : row.groupId == undefined ? this.userGroupId ?? -1 : row.groupId,
                            userId       : row.userId,
                            // externalRef  : "",
                            fullname     : "",
                            // internalRef  : "",
                            groupName    : "",
                            username     : "",
                          };

          this.userGroup?.allocations.push(newItem);
        } else {
          this.userGroup!.allocations[index].changed  = true;
          this.userGroup!.allocations[index].excluded = false;
          this.userGroup!.allocations[index].included = true;
        }
      }

      this.repaintUserGroupGrid();
      this.gridViewGroups.dataGrid.instance.repaintRows;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }

  public groupsRemoveButtonClick(e: any) {
    try {
      let row = e.row.data;
      if (row != null)
      {
        row.included   = false;
        row.excluded   = true;
        row.changed    = true;

        let index = this.userGroup?.allocations.findIndex(item => item.groupId === row.groupId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active       : true,
                            changed      : true,
                            companyID    : row.companyID,
                            deleted      : false,
                            enteredBy    : this.curUser.userId,
                            enteredDate  : new Date(2025, 1, 1, 0, 0, 0, 0),
                            excluded     : true,
                            id           : row.id,
                            included     : false,
                            systemOwned  : false,
                            groupId      : row.groupId,
                            userId       : row.userId,
                            // externalRef  : "",
                            fullname     : "",
                            // internalRef  : "",
                            groupName    : "",
                            username     : "",
                          };

          this.userGroup?.allocations.push(newItem);
        } else {
          this.userGroup!.allocations[index].changed  = true;
          this.userGroup!.allocations[index].excluded = true;
          this.userGroup!.allocations[index].included = false;
        }
      }

      //this.repaintUserGroupGrid();
      this.reapplyFilterGroups();
      this.gridViewGroups.dataGrid.instance.repaintRows;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }

  public includeAllGroups() {
    const gridInstance = this.gridViewGroups.dataGrid.instance; 
    var combinedFilter = gridInstance.getCombinedFilter();
    var datasource     = gridInstance.getDataSource();
    datasource.store().load({ filter: combinedFilter }).then((data) => {
      var rows = data as UserGroupAllocationDTO[];
      rows.forEach((item) => {
        item.changed = true;
        item.excluded= false;
        item.included= true;
        let index = this.userGroup?.allocations.findIndex(itemb => itemb.groupId === item.groupId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active       : true,
                            changed      : true,
                            companyID    : item.companyID,
                            deleted      : false,
                            enteredBy    : this.curUser.userId,
                            enteredDate  : new Date(2025, 1, 1, 0, 0, 0, 0),
                            excluded     : false,
                            id           : item.id,
                            included     : true,
                            systemOwned  : false,
                            groupId      : item.groupId,
                            userId       : item.userId,
                            // externalRef  : "",
                            fullname     : "",
                            // internalRef  : "",
                            groupName    : "",
                            username     : "",
                          };

          this.userGroup?.allocations.push(newItem);
        } else {
          this.userGroup!.allocations[index].changed  = true;
          this.userGroup!.allocations[index].excluded = false;
          this.userGroup!.allocations[index].included = true;
        }
      }
    )});

    this.repaintUserGroupGrid();
  }

  public removeAllGroups() {
    const gridInstance = this.gridViewGroups.dataGrid.instance;  
    var combinedFilter = gridInstance.getCombinedFilter();
    var datasource = gridInstance.getDataSource();
    datasource.store().load({ filter: combinedFilter }).then((data) => {
      var rows = data as UserGroupAllocationDTO[];
      rows.forEach((item) => {
        item.changed = true;
        item.excluded= true;
        item.included= false;
        let index = this.userGroup?.allocations.findIndex(itemb => itemb.groupId === item.groupId);

        if (index == -1 || index == undefined) {
          const newItem = {
                            active       : true,
                            changed      : true,
                            companyID    : item.companyID,
                            deleted      : false,
                            enteredBy    : this.curUser.userId,
                            enteredDate  : new Date(2025, 1, 1, 0, 0, 0, 0),
                            excluded     : true,
                            id           : item.id,
                            included     : false,
                            systemOwned  : false,
                            groupId      : item.groupId,
                            userId       : item.userId,
                            // externalRef  : "",
                            fullname     : "",
                            // internalRef  : "",
                            groupName    : "",
                            username     : "",
                          };

          this.userGroup?.allocations.push(newItem);
        } else {
          this.userGroup!.allocations[index].changed  = true;
          this.userGroup!.allocations[index].excluded = true;
          this.userGroup!.allocations[index].included = false;
        }
      }
    )});

    //this.setUpDgColumnsGroups();
    this.repaintUserGroupGrid();
  }

  public async onAllSimsCheckboxChange(event: Event): Promise<void> {
    const isChecked = (event.target as HTMLInputElement).checked;
    await this.setDgApiPathGetUsers(true);
  }

  //#endregion

  //#region Process Complete

  public completedModalHasBeenClosed() {
    try {
      if (this.embeddedFormMode) {
        this.startProcess();
      } 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region SureSIM Data

  public refreshData() {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

}
